import {
  ResponseFill,
  HttpIgnore, IResource,
} from 'simpli-web-sdk'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import * as Helper from '@/helpers'
import DateFilterRequest from '@/model/request/DateFilterRequest'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import {ItrackCollection} from '@/helpers'
import {TipoSistema} from '@/enums/TipoSistema'
import {DeliveryAudit} from '@/enums/DeliveryAudit'

@HttpIgnore()
export default class DeliveryReceiverRequest extends DateFilterRequest {
  readonly $name: string = 'DeliveryReceiverRequest'

  allSistema = ItrackCollection.allSistema
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get regionCollection() {
    return ItrackCollection.allRegion.prependNull('app.all')
  }

  get auditCollection() {
    return ItrackCollection.allAudit.prependNull('app.all')
  }

  idFilial = Helper.getIdFilial()

  @ResponseFill()
  cpfCnpj: string | null = null

  cargaDestinatario =  new CargaDestinatario()

  @ResponseFill()
  uf: UF | null = null

  @ResponseFill()
  region: Region | null = null

  @ResponseFill()
  cidade: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill()
  idCentroDeCusto: number | null = null

  @ResponseFill()
  idInsumo: number | null = null

  @ResponseFill()
  idTipoCriacao: number | null = null

  @ResponseFill()
  idTipoFinalizacao: number | null = null

  @ResponseFill()
  auditoria: number | null = null

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get regionResource() {
    return this.regionCollection.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get centroDeCustoResource() {
    return this.allCentroDeCusto.get(this.idCentroDeCusto)
  }
  set centroDeCustoResource(val: IResource | null) {
    this.idCentroDeCusto = val && val.$id as number || null
  }

  get insumoResource() {
    return this.allTipoInsumo.get(this.idInsumo)
  }
  set insumoCustoResource(val: IResource | null) {
    this.idInsumo = val && val.$id as number || null
  }

  get tipoFinalizacaoResource() {
    return this.allSistema.get(this.idTipoFinalizacao)
  }
  set tipoFinalizacaoResource(val: IResource | null) {
    this.idTipoFinalizacao = val && val.$id as TipoSistema || null
  }

  get tipoCriacaoResource() {
    return this.allSistema.get(this.idTipoCriacao)
  }
  set tipoCriacaoResource(val: IResource | null) {
    this.idTipoCriacao = val && val.$id as TipoSistema || null
  }

  get auditResource() {
    return this.auditCollection.get(this.auditoria)
  }
  set auditResource(val: IResource | null) {
    this.auditoria = val && val.$id as DeliveryAudit || null
  }
}
